export default __webpack_public_path__ + "static/medium-6dd20a8da5b1c28b8df2a93f13840060.woff2";